/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Internal_Only_BadgeInputs */



/**
* | output |
* | --- |
* | "Internal sources only" |
*
* @param {Rag_Internal_Only_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_internal_only_badge = /** @type {((inputs?: Rag_Internal_Only_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Internal_Only_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur interne Quellen")
	return /** @type {LocalizedString} */ ("Internal sources only")
});